<template>
  <b-modal
    :id="target"
    title="Dépannage"
    scrollable
    hide-footer
    size="lg">
    <b-row class="justify-content-md-center pb-md-3">
      <b-col
        align-self="center"
        class="text-center">
        Dépanner le {{ getTroubleType() }} : {{ label }}
      </b-col>
    </b-row>
    <list-devices
      :devices="devices"
      :full="false"
      @fix="callFix"/>
  </b-modal>
</template>

<script>

import ListDevices from './lists/ListDevices.vue';
import { operationBus } from '../main';
import {reportTroublesShoot} from '../services/establishment'

export default {
  name: 'ModalTroubleshoot',
  components: { ListDevices },
  props: {
    target: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
    devices: {
      type: Array,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    esta_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      title: 'Modale Troubleshoot',
    };
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    getTroubleType() {
      switch (this.type) {
        case 'modu':
          return 'module';
        case 'par':
          return 'participant';
        case 'staf':
          return 'membre du personnel';
        default:
          return 'inconnu';
      }
    },
    callFix(device) {
      const params = {
        id: this.id,
        esta_id: this.esta_id,
        type: this.type,
        dev_id: device.dev_id,
      }
      reportTroublesShoot(params)
    },
  },
};
</script>
<style>

</style>
